import { Trans } from "@coworker/locales";
import { Widget } from "@coworker/components/src/components/Widget";
import SelectAmount from "@coworker/components/src/components/SelectAmount";
import { useInputPopup } from "../../InputPopup";
import { useLocationCapacity } from "../../../hooks/Locations/useLocationCapacity";
import useFormatter from "../../../hooks/useFormatter";
import { useAvailableElevatedStock } from "../../../hooks/useAvailableElevatedStock";
import amountTypeOptions from "@coworker/enums/amountTypes";
import { evaluateIsFoodArticle } from "@coworker/app/src/helpers/utils";

export default function TaskFormAmount({
  value: {
    quantity,
    actualQuantity,
    type,
    productId,
    location,
    articleType,
    requestedQuantity,
    piecesPerMultiPack,
    piecesPerPallet,
    panumber,
  },
  conf: { changeName, changeTitle, deactivated, overridePadding } = {},
  onChange,
  additionalSubTitle,
}) {
  const full_id = `${articleType}${productId}`;
  const maxRefillForLocation = useLocationCapacity(location, full_id);
  const isFoodArticle = evaluateIsFoodArticle(panumber);

  const { getInput } = useInputPopup();
  const { available } = useAvailableElevatedStock(articleType + productId);

  const pieces = quantity;

  const { productUnit } = useFormatter();
  const baseUnitType = amountTypeOptions.PIECES;
  const baseUnit = productUnit(baseUnitType, pieces);
  const guessEnteredAmount = () => {
    if (!!type && pieces >= 0) {
      return type === amountTypeOptions.MULTI_PACK
        ? pieces / piecesPerMultiPack
        : type === amountTypeOptions.PALLET
          ? pieces / piecesPerPallet
          : pieces;
    }
  };

  const enteredAmount = actualQuantity ?? guessEnteredAmount();

  const getAmount = async () => {
    const data = await getInput("selectAmount", {
      title: <Trans>piecesString</Trans>,
      oldAmount: pieces,
      oldActualAmount: enteredAmount,
      oldAmountType: type,
      baseUnit,
      baseUnitType,
      maxAmount: maxRefillForLocation,
      initializeWithOldAmount: true,
      changeName,
      changeTitle,
      requestedQuantity,
      available,
      isFoodArticle,
    });

    if (data) onChange(data);
  };

  // TODO: Rework so SelectAmount can avoid complex logic and duplicated parameters (amount vs enteredAmount)
  return (
    <Widget onClick={getAmount} data-testid={"amount"}>
      <SelectAmount
        amount={pieces}
        type={type}
        baseUnit={baseUnit}
        deactivated={deactivated != null ? deactivated : isNaN(pieces)} // TODO: Explain why isNaN is good enough, or otherwise bugfix.
        overridePadding={overridePadding}
        enteredAmount={enteredAmount}
        typeString={productUnit(type, enteredAmount)}
        additionalSubTitle={!pieces ? additionalSubTitle : <></>}
      />
    </Widget>
  );
}
